let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("51J6P")).then(() => parcelRequire('5qYHs'));